<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Xem Lớp học: {{ modelData.code }} (<span class="color-red">{{ totalStudent(table.database.data_result) }} học viên</span>)
        </h2>
        <div>
          <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
        </div>

      </div>

      <el-row :gutter="20">
        <el-col :span="8">
          <div>
            <h3><strong>Trường: </strong> <span>{{ modelData.school_text }}</span></h3>
            <h3><strong>Phân hệ: </strong> <span>{{ modelData.level_text }}</span></h3>
            <h3><strong>Chuyên ngành: </strong> <span>{{ modelData.facult_text }}</span></h3>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <h3><strong>Tổng số học sinh đã hoàn thành: </strong> <span class="color-red">{{ table.database.total_done_all }}</span>
            </h3>
            <h3><strong>Tổng số học sinh đang học: </strong> <span class="color-red">{{ table.database.total_done_center }}</span>
            </h3>
            <h3><strong>Tổng số học sinh chưa bắt đầu: </strong> <span class="color-red">{{ table.database.total_done_none }}</span>
            </h3>
          </div>
        </el-col>
        <el-col :span="8">
          <el-button type="primary" plain @click="showScoreType4">Xem Bình Luận</el-button>
          <el-button type="primary" plain @click="showStudentListPrint()"><i class="fas fa-print"></i> In Danh Sách
          </el-button>
          <el-button type="primary" plain @click="createEvent">Tạo mới sự kiện</el-button>
        </el-col>
      </el-row>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database.data_result"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            prop="name"
            width="200"
            label="Học viên">
            <template slot-scope="scope">
              <div class="courses-info">
                <span style="font-weight: bold">{{ scope.row.user_name }}</span>
                <span>{{ scope.row.user_email }}</span>
                <span>{{ scope.row.user_code }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Trắc nghiệm">
            <template slot-scope="scope">
              <span class="color-red click-point" @click="showScoreType1(scope.row)">{{
                  scope.row.my_testKit_type_1
                }}/{{ scope.row.testKit_type_1 }} <i class="fas fa-plus"></i></span>
            </template>
          </el-table-column>
          <el-table-column
            label="Bài tập">
            <template slot-scope="scope">
              <span class="color-red click-point" @click="showScoreType2(scope.row)">{{
                  scope.row.my_testKit_type_2
                }}/{{ scope.row.testKit_type_2 }} <i class="fas fa-plus"></i></span>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="Tiến độ">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.percentV2" class="click-point"
                           @click="showScoreType3(scope.row)"></el-progress>
              <span class="click-point" @click="showScoreType3(scope.row)">Chi tiết</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="Time(giờ)">
            <template slot-scope="scope">
              <p>{{ scope.row.my_time }} h</p>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="Điểm sơ bộ">
            <template slot-scope="scope">
              <p class="color-red">0%</p>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="Điểm chính thức">
            <template slot-scope="scope">
              <p class="color-red">0%</p>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="Xếp loại">
            <template slot-scope="scope">
              <span class="color-red">{{ scope.row.rating }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="Nhận xét">
            <template slot-scope="scope">
              <span style="display: block; cursor: pointer" @click="showScoreType5(scope.row.comment, scope.row.class_user_id)">
                <svg style="width: 22px;" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ea893728=""><path
                  fill="currentColor"
                  d="M736 504a56 56 0 1 1 0-112 56 56 0 0 1 0 112zm-224 0a56 56 0 1 1 0-112 56 56 0 0 1 0 112zm-224 0a56 56 0 1 1 0-112 56 56 0 0 1 0 112zM128 128v640h192v160l224-160h352V128H128z"></path></svg>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="Chứng chỉ">
            <template slot-scope="scope">
              <span style="display: block; cursor: pointer" @click="showScoreType6(scope.row.certificate, scope.row.class_user_id)">
                <svg style="width: 22px;" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ea893728=""><path
                  fill="currentColor"
                  d="M576 128v288l96-96 96 96V128h128v768H320V128h256zm-448 0h128v768H128V128z"></path></svg>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="Xem bảng điểm"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <el-tooltip effect="dark" content="Xem điểm" placement="top">
                  <span @click="showScore(scope.row)">
                    <i class="far fa-window-restore"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="In" placement="top">
                  <span @click="showPrint(scope.row)">
                    <i class="fas fa-print"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>

    <el-dialog title="Bảng điểm trắc nghiệm" :visible.sync="dialogTableVisible">
      <div data-v-038f23da="" class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition">
        <div class="hidden-columns">
          <div data-v-038f23da=""></div>
          <div data-v-038f23da=""></div>
          <div data-v-038f23da=""></div>
          <div data-v-038f23da=""></div>
        </div>
        <div class="el-table__header-wrapper">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%;">
            <colgroup>
              <col name="el-table_11_column_89" width="50">
              <col name="el-table_11_column_90" width="430">
              <col name="el-table_11_column_91" width="100">
              <col name="el-table_11_column_92" width="100">
            </colgroup>
            <thead class="">
            <tr class="">
              <th colspan="1" rowspan="1" class="el-table_11_column_89 is-center is-leaf">
                <div class="cell">STT</div>
              </th>
              <th colspan="1" rowspan="1" class="el-table_11_column_90 is-leaf">
                <div class="cell">Tên đề thi</div>
              </th>
              <th colspan="1" rowspan="1" class="el-table_11_column_91 is-leaf">
                <div class="cell">Điểm sổ</div>
              </th>
              <th colspan="1" rowspan="1" class="el-table_11_column_92 is-leaf">
                <div class="cell">Download</div>
              </th>
            </tr>
            </thead>
          </table>
        </div>
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
            <colgroup>
              <col name="el-table_11_column_89" width="50">
              <col name="el-table_11_column_90" width="430">
              <col name="el-table_11_column_91" width="100">
              <col name="el-table_11_column_92" width="100">
            </colgroup>
            <tbody>
            <!--loop-->
            <tr class="el-table__row" v-for="(item, index) in itemClick.arr_my_testKit_type_1" :key="index">
              <td class="el-table_11_column_89 is-center ">
                <div class="cell">
                  <div>{{index + 1}}</div>
                </div>
              </td>
              <td class="el-table_11_column_90  ">
                <div class="cell">{{item.test_kit_name}}</div>
              </td>
              <td class="el-table_11_column_91  ">
                <div class="cell">{{item.score}}</div>
              </td>
              <td class="el-table_11_column_92  ">
                <div class="cell">
                  <button type="button" aria-disabled="false" class="el-button el-button--primary is-link" @click="showPrintTestResult(item.id)">Link</button>
                </div>
              </td>
            </tr>
            <!--end loop-->
            </tbody>
          </table><!---->
          <!---->
        </div><!---->
        <!---->
        <!---->
        <!---->
        <div class="el-table__column-resize-proxy" style="display: none;"></div>
        <div class="resize-triggers">
          <div class="expand-trigger">
            <div style="width: 681px; height: 146px;"></div>
          </div>
          <div class="contract-trigger"></div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="Bảng điểm tự luận" :visible.sync="dialogTableVisible2">
      <el-table :data="itemClick.arr_my_testKit_type_2">
        <el-table-column
          label="STT"
          type="index"
          width="50"
          align="center"
          header-align="center"
        >
        </el-table-column>
        <el-table-column property="test_kit_name" label="Tên đề thi"></el-table-column>
        <el-table-column property="score" label="Điểm sổ" width="100"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="Tiến độ học tập" :visible.sync="dialogTableVisible3">
      <el-table :data="processBooking" v-loading="processBookingLoading">
        <el-table-column
          label="STT"
          type="index"
          width="50"
          align="center"
          header-align="center"
        >
        </el-table-column>
        <el-table-column property="course_name" label="Môn học"></el-table-column>
        <el-table-column label="Tiến độ">
          <template slot-scope="scope">
            <el-progress :percentage="scope.row.percent_comple"></el-progress>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog width="70%" title="Nhận xét của học viên" :visible.sync="dialogTableVisible4">
      <el-table
        :data="pagedTableData"
        style="width: 100%">
        <el-table-column
          label="#"
          type="index"
          width="40">
        </el-table-column>
        <el-table-column
          label="Học viên">
          <template slot-scope="scope">
            <div class="courses-info">
              <span style="font-weight: bold">{{ scope.row.user.name }}</span>
              <span style="font-weight: bold">{{ scope.row.user.email }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Chương">
          <template slot-scope="scope">
            <div class="courses-info">
              <span style="font-weight: bold">{{ scope.row.chapters.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Nội dung">
          <template slot-scope="scope">
            <div class="courses-info">
              <span style="font-weight: bold">{{ scope.row.content }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-divider></el-divider>
      <div style="text-align: center" class="mt-2">
        <el-pagination
          @current-change="setPage"
          layout="prev, pager, next"
          :total="commentTotalPage">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog title="Nhận xét của Giáo viên" :visible.sync="dialogTableVisible5">
      <el-form :model="commentOfTeacher" label-width="120px">
        <div>
          <input type="hidden" v-model="classUserId">
          <el-input
            v-model="commentOfTeacher.comment"
            :rows="4"
            type="textarea"
            placeholder="Nhập bình luận của Giáo viên..."/>
        </div>
        <div class="mt-3">
          <div style="display: block; margin-left: auto; width: max-content">
            <el-button type="primary" @click="onCommentTeacher">Tạo</el-button>
            <el-button @click="closeCommentOfTeacher">Huỷ</el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog title="Chứng chỉ của Học viên" :visible.sync="dialogTableVisible6">
        <div>
          <!--===-->
            <el-upload
              :action="upload.uploadCertificate"
              list-type="picture-card"
              :headers="upload.headers"
              :before-upload="beforeAvatarUpload"
              :on-preview="handlePictureCardPreview"
              :on-progress="handleAvatarProcess"
              :on-success="handleAvatarSuccess"
              :on-remove="handleRemove"
              :file-list="fileList"
              :limit="10"
              :auto-upload="true">
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
                {{file.url}}
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url" alt=""
                >
              </div>
            </el-upload>

            <el-dialog :visible.sync="dialogVisible" append-to-body>
              <img width="100%" :src="dialogImageUrl" alt="Preview Image" style="z-index: 1">
            </el-dialog>
          <!--===-->
        </div>
        <div class="mt-3">
          <div style="display: block; margin-left: auto; width: max-content">
            <el-button @click="closeCertificate">Đóng</el-button>
          </div>
        </div>
    </el-dialog>
    <el-dialog  title="Thêm mới sự kiện" :visible.sync="dialogAddVisible" width="30%">
<!--      <div class="row">-->
<!--        <div class="col-md-6">-->
<!--          <el-button type="primary" @click="openDialogEvent('class-live')">Thêm mới lớp học</el-button>-->
<!--        </div>-->
<!--        <div class="col-md-6">-->
<!--          <el-button type="primary" @click="openDialogEvent('test-room')">Thêm mới phòng thi</el-button>-->
<!--        </div>-->
<!--      </div>-->
      <el-button type="primary" @click="openDialogEvent('class-live')">Thêm mới lớp học</el-button>
      <el-button type="primary" @click="openDialogEvent('test-room')">Thêm mới phòng thi</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAddVisible = false">Đóng</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import { head } from 'lodash'
  import { mapActions } from 'vuex'
  import ls from "local-storage";
  export default {
    name: 'PromotionShow',
    metaInfo() {
      return {
        title: 'Lớp học'
      }
    },
    components: {},
    data() {
      return {
        dialogAddVisible: false,
        loading: false,
        canSubmit: true,
        class_user_id: '',
        id: '',
        filter: {
          q: '',
          status: 1,
          date: '',
          school_id: '',
          level_id: '',
          facult_id: '',
          staff_id: '',
          page: 1,
          limit: 15,
          sorted: ''
        },
        modelData: {
          status: true
        },
        table: {
          database: [],
          meta_pagination: 0,
          pagination: {
            total: 0,
            count: 0,
            per_page: 0,
            current_page: 1,
            total_pages: 0
          },
          timer: {}
        },
        page: 1,
        pageSize: 10,

        dialogTableVisible: false,
        dialogTableVisible2: false,
        dialogTableVisible3: false,
        dialogTableVisible4: false,
        dialogTableVisible5: false,
        dialogTableVisible6: false,
        itemClick: {},
        processBooking: [], // Tiến trình học
        processBookingLoading: false,
        commentOfTeacher: {
          comment: '',
        },
        classUserId: '',
        fileList: [
          // {name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'},
          // {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}
          ],
        upload: {
          uploadProcess: false,
          uploadCertificate: process.env.API_URI + 'class-users/update-certificate-of-student/' + this.classUserId,
          headers: {
            Authorization: ''
          }
        },
        ////////
        dialogImageUrl: '',
        dialogVisible: false,
        disabled: false
      }
    },
    mounted() {
      this.configBreadcrumb()
      this.fetchModel()
      this.filter.class_pro_id = this.$route.params.id
      this.fetchDatabaseModel()
      this.configUpload()
    },
    computed: {
      pagedTableData() {
        if (this.table.database.comments && this.table.database.comments.length) {
          return this.table.database.comments.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)
        }
        return 0
      },
      commentTotalPage() {
        if (this.table.database.comments && this.table.database.comments.length) {
          return this.table.database.comments.length
        }
        return 0
      }
    },
    methods: {
      // Lấy action từ Vuex
      ...mapActions(['setBreadcrumb']),
      openDialogEvent(event) {
          if(event === 'class-live') {
            this.$router.push({name: 'class-live-create-of-class', params: {id: this.$route.params.id}})
          } else {
            this.$router.push({name: 'test-room-create-of-class', params: {id: this.$route.params.id}})
          }
      },
      // ====
      handleRemove(file) {
        let data = {
          class_user_id: this.classUserId,
          image_url:  file.name
        }
        axios.post('class-users/remove-certificate-of-student', data).then(response => {
          this.processBookingLoading = false
          switch (response.code) {
            case 200:
              this.fetchDatabaseModel()
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xẳy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },

      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },

      // ====
      configUpload () {
        const token = ls.get('authen', '')
        if (token) {
          this.upload.headers.Authorization = `Bearer ${token.access_token}`
        } else {
          this.upload.headers.Authorization = 'Bearer'
        }
      },
      // Upload Ảnh
      beforeAvatarUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isLt2M) {
          this.$message.error('Ảnh trường có dung lượng ảnh tối đa là 2M')
        }
        return isLt2M
      },
      handleAvatarSuccess (response) {
        this.upload.uploadProcess = false
        if (response.code) {
          this.fetchDatabaseModel()
        }
      },
      handleAvatarProcess (event, file, fileList) {
        this.upload.uploadProcess = true
      },

      beforeFaviconUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isLt2M) {
          this.$message.error('Ảnh trường có dung lượng ảnh tối đa là 2M')
        }
        return isLt2M
      },

      getImage (data) {
        return process.env.IMAGE_S3_URL + 'storage/certificate/' + data
      },

      closeCommentOfTeacher () {
        this.dialogTableVisible5 = false
      },
      closeCertificate () {
        this.dialogTableVisible6 = false
      },
      // Cấu hình Breadcrumb
      configBreadcrumb() {
        let breadcrumb = [
          {name: 'home-index', text: 'Trang chủ'},
          {name: 'class-pros-index', text: 'Lớp học'},
          {name: 'class-pros-update', text: 'Xem bảng điểm'}
        ]
        this.setBreadcrumb(breadcrumb)
      },
      // Nút back lại trang Index
      backModel() {
        this.$router.push({name: 'class-pros-index'})
      },
      // Xem điểm
      showScore(model) {
        this.$router.push({name: 'class-pros-show-score', params: {id: this.$route.params.id, id_class_user: model.id}})
      },
      showPrint(model) {
        let routeData = this.$router.resolve({
          name: 'class-pros-show-print',
          params: {id: this.$route.params.id, id_class_user: model.id}
        })
        window.open(routeData.href, '_blank')
      },
      showPrintTestResult(idPrintTestResult) {
        let routeData = this.$router.resolve({
          name: 'print-test-result',
          params: {id: this.$route.params.id, id_class_user: this.class_user_id, id_test_result: idPrintTestResult}
        })
        window.open(routeData.href, '_blank')
      },
      // In danh sách học viên
      showStudentListPrint() {
        let routeData = this.$router.resolve({
          name: 'class-pros-show-student-list-print',
          params: {id: this.$route.params.id}
        })
        window.open(routeData.href, '_blank')
      },
      // Tải dữ liệu Model xuống
      fetchModel() {
        this.canSubmit = false
        axios.get('class-pros/' + this.$route.params.id).then(response => {
          switch (response.code) {
            case 200:
              this.canSubmit = true
              this.modelData = response.data
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },
      // Fetch dữ liệu
      fetchDatabaseModel() {
        this.loading = true
        axios.post('class-pros/show-list-user/' + this.$route.params.id).then(response => {
          this.loading = false
          switch (response.code) {
            case 200:
              this.table.database = response.data
              this.closeCommentOfTeacher()
              // this.table.pagination = response.meta.pagination
              // this.caculaterMetaPagination()
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xẳy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },
      // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
      caculaterMetaPagination() {
        if (this.table.pagination.current_page === this.table.pagination.total_pages) {
          this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
        } else {
          this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
        }
      },
      // Thay đổi Current Page
      changeCurrentPage(currentPage) {
        this.filter.page = currentPage
        this.fetchDatabaseModel()
      },

      showScoreType1(item) {
        this.id = item.id
        this.class_user_id = item.class_user_id
        this.itemClick = item
        this.dialogTableVisible = true
      },
      showScoreType2(item) {
        this.itemClick = item
        this.dialogTableVisible2 = true
      },
      showScoreType3(item) {
        this.dialogTableVisible3 = true
        this.processBooking = []
        this.processBookingLoading = true

        let data = {
          user_id: item.user_id
        }
        axios.post('class-pros/show-list-booking-user/' + this.$route.params.id, data).then(response => {
          this.processBookingLoading = false
          switch (response.code) {
            case 200:
              this.processBooking = response.data
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xẳy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },
      showScoreType4() {
        this.dialogTableVisible4 = true
      },
      showScoreType5(comment, classUserId) {
        this.dialogTableVisible5 = true
        this.commentOfTeacher.comment = comment
        this.classuserId = classUserId
      },
      showScoreType6(certificate, classUserId) {
        this.dialogTableVisible6 = true
        this.classUserId = classUserId
        this.upload.uploadCertificate = process.env.API_URI + 'class-users/update-certificate-of-student/' + classUserId
        if(!certificate) {
          return
        }
        this.fileList = []
        let certificates = certificate.split(",")
        certificates.forEach((element, index) => {
          this.fileList.push({
            name: element,
            url: process.env.IMAGE_S3_URL + element
          });
        });
      },
      setPage(val) {
        this.page = val
      },
      totalStudent(value) {
        return value && value.length ? value.length : 0
      },
      onCommentTeacher () {
        let data = {
          class_user_id: this.classuserId,
          comment: this.commentOfTeacher.comment
        }
         axios.post('class-users/update-comment-of-teacher', data).then(response => {
          this.processBookingLoading = false
          switch (response.code) {
            case 200:
              this.fetchDatabaseModel()
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xẳy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },
      createEvent() {
        this.dialogAddVisible = true
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
  .model-content {
    padding-top: 15px;
  }

  .courses-info {
    display: flex;
    flex-direction: column;
  }

  .courses-info span {
    margin-bottom: 5px;
  }

  .color-red {
    color: red;
    font-weight: bold;
  }

  .color-red i {
    color: green;
  }

  .color-blue {
    color: blue;
    font-weight: bold;
  }

  .click-point {
    cursor: pointer;
  }
</style>
<style>
  .course-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100px;
    height: 100px;
    display: block;
  }
  .v-modal {
    /*background: transparent !important;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/class-pros/ShowListUser.vue